export default __webpack_public_path__ + "static/media/Rafael.c27ef32a.png";